<mat-progress-bar [color]="color" mode="determinate" [value]="progress" [attr.aria-label]="'COMPONENTS.TILE.STATUS' | translate"></mat-progress-bar>
